<app-page-title *ngIf="administrator" icon="fa-file" title="Relatório de faturamento">
  <button type="button" class="btn btn-primary" (click)="download()">
    <i class="fa fa-download"></i>
    Download CSV
  </button>
</app-page-title>

<section class="reports" *ngIf="administrator">
  <div class="row">
    <div class="col-md-2" style="width: fit-content;">
      <div class="form-group">
          <mat-form-field>
            <mat-label>Data inicial</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="startDate">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <small
            class="text text-danger"
            *ngIf="startDate && endDate && startDate > endDate"
            >Período inválido.</small
          >
          </mat-form-field>
        </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
          <mat-form-field>
            <mat-label>Data final</mat-label>
            <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate">
            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
            <small
            class="text text-danger"
            *ngIf="startDate && endDate && startDate > endDate"
            >Período inválido.</small
          >
          </mat-form-field>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group report-filter">
        <label for="profile_id">Perfil</label>
        <div *ngIf="profiles$ | async as profiles; else loadingProfiles">
          <select
            id="profile_id"
            name="profile_id"
            class="form-control"
            [(ngModel)]="profileId"
            data-testid="select-report-profile"
          >
            <option value="">Todos</option>
            <option *ngFor="let profile of profiles" [value]="profile.id">
              {{ profile.name }}
            </option>
          </select>
        </div>
        <div class="report-filter__actions mt-2">
          <button
            type="button"
            class="btn me-2 btn-primary"
            (click)="search()"
            data-testid="btn-search-report"
          >
            <i class="fa fa-search"></i>
            <span>Pesquisar</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="clearFilters()"
            data-testid="btn-clear-report-filters"
          >
            <i class="fa fa-times"></i>
            <span>Limpar</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="searched && result">
  <div class="row d-flex billing-cards">
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card" data-testid="card-signature-billing">
        <h2>Assinaturas</h2>
        <h3 class="fa-2x">
          <b>{{ signatureBilling | numberFormat : "" : true }}</b>
        </h3>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card" data-testid="card-sms-billing">
        <h2>Recargas SMS</h2>
        <h3 class="fa-2x">
          <b>{{ smsBilling | numberFormat : "" : true }}</b>
        </h3>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card" data-testid="card-call-billing">
        <h2>Recargas Ligação</h2>
        <h3 class="fa-2x">
          <b>{{ callBilling | numberFormat : "" : true }}</b>
        </h3>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card total" data-testid="card-total-billing">
        <h2>Total</h2>
        <h3 class="fa-2x">
          <b>{{ billing | numberFormat : "" : true }}</b>
        </h3>
      </div>
    </div>
  </div>
  <table class="table table-hover">
    <thead>
      <tr>
        <th>Usuário</th>
        <th class="text-right">Valor Assinatura</th>
        <th class="text-right">Valor Recargas SMS</th>
        <th class="text-right">Valor Recargas Ligação</th>
        <th class="text-right">Total</th>
      </tr>
    </thead>
    <tbody *ngIf="loading">
      <tr>
        <td colspan="9999">
          <app-skeleton variant="table-row" [count]="8" [columns]="5"
            label="Carregando o relatório de faturamento"></app-skeleton>
        </td>
      </tr>
    </tbody>

    <tbody *ngIf="!loading && result?.data.length > 0; else notRecharges">
      <tr *ngFor="let user of result?.data">
        <td>{{ user.name }}</td>
        <td class="text-right">
          {{ user.credit_info.signature_billing | numberFormat : "" : true }}
        </td>
        <td class="text-right">
          {{ user.credit_info.sms_billing | numberFormat : "" : true }}
        </td>
        <td class="text-right">
          {{ user.credit_info.call_billing | numberFormat : "" : true }}
        </td>
        <td class="text-right">
          {{
            getTotalBilling(user.credit_info) | numberFormat : "" : true
          }}
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr *ngIf="totalCreditsInfo">
        <td>Total</td>
        <td class="text-right">
          {{ totalCreditsInfo.signature_billing | numberFormat : "" : true }}
        </td>
        <td class="text-right">
          {{ totalCreditsInfo.sms_billing | numberFormat : "" : true }}
        </td>
        <td class="text-right">
          {{ totalCreditsInfo.call_billing | numberFormat : "" : true }}
        </td>
        <td class="text-right">
          {{ getTotalBilling(totalCreditsInfo) | numberFormat : "" : true }}
        </td>
      </tr>
    </tfoot>
  </table>
  <app-pagination
    *ngIf="result"
    [currentPage]="result.current_page"
    [itemsPerPage]="result.per_page"
    [totalItems]="result.total"
    (pageChanged)="pageChanged($event)"
  ></app-pagination>
  </ng-container>
</section>

<ng-template #notRecharges>
  <tbody>
    <tr>
      <td colspan="7">Nenhum usuário encontrado.</td>
    </tr>
  </tbody>
</ng-template>

<ng-template #loadingProfiles>
  <span class="form-control">
    Carregando...
  </span>
</ng-template>
